import { Paper } from '@material-ui/core'
import { Engineering } from '@mui/icons-material'
import React from 'react'
import style from './index.module.css'

const UnderMaintenance = () => (
  <div className={ style.container }>
    <Engineering className={ style.icon } />
    <b>This page is under maintenance</b>
  </div>
)

export default UnderMaintenance
